<template>
  <div style="padding: 10px; margin-bottom: 50px">
    <el-row>
      <el-col :span="4">
        <el-card style="width: 300px; height: 300px; color: #333">
          <div style="color:#6e44c0 ;padding-bottom: 10px; border-bottom: 1px solid #ccc">在线人数<span style="font-size: 12px"> {{users.length}}</span></div>
<!--          <span style="padding: 10px;background: #FFFFFF" v-for="user in users" :key="user.username">
            <span>{{ user.username }}</span>
&lt;!&ndash;            <button color="orange" @click.prevent="chatUser = user.username" size="small" type="info" ghost style="margin: 4px">私聊</button>
            <span style="font-size: 12px;color: limegreen; margin-left: 5px" v-if="user.username === chatUser">chatting...</span>&ndash;&gt;
          </span>-->
        </el-card>
      </el-col>
      <el-col :span="20">
        <div style="width: 800px; margin: 0 auto; background-color: white;
                    border-radius: 5px; box-shadow: 0 0 10px #ccc">
          <div style="text-align: center; line-height: 50px;">
            书信阁（{{ chatUser }}）
          </div>
          <div style="height: 350px; overflow:auto; border-top: 1px solid #ccc" v-html="content"></div>
          <div style="height: 200px">
            <textarea v-model="text" style="height: 160px; width: 100%; padding: 20px; border: none; border-top: 1px solid #ccc;
             border-bottom: 1px solid #ccc; outline: none"></textarea>
            <div style="text-align: right; padding-right: 10px">
              <el-button type="primary" size="mini" @click="send">发送</el-button>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>

</template>
<script>
// 监听窗口关闭事件，当窗口关闭时，主动去关闭websocket连接，防止连接还没断开就关闭窗口，server端会抛异常。
/*window.onbeforeunload = function() {
  this.ws.close();
}*/
export default {
  name: "Im",
  data() {
    return {
      circleUrl: 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png',
      user: {},
      isCollapse: false,
      users: [],
      chatPindao:"桑林村村口",
      wsUrl:"",
      chatUser: '',
      lockReconnect : false,  // 避免ws重复连接
      ws : null,          // 判断当前浏览器是否支持WebSocket
      text: "",
      messages: [],
      content: '',
      // websocket相关
      socketObj: "", // websocket实例对象a
      //心跳检测
      heartCheck: {
        vueThis: this, // vue实例
        timeout: 10000, // 超时时间
        timeoutObj: null, // 计时器对象——向后端发送心跳检测
        serverTimeoutObj: null, // 计时器对象——等待后端心跳检测的回复
        // 心跳检测重置
        reset: function () {
          clearTimeout(this.timeoutObj);
          clearTimeout(this.serverTimeoutObj);
          return this;
        },
        // 心跳检测启动
        start: function () {
          this.timeoutObj && clearTimeout(this.timeoutObj);
          this.serverTimeoutObj && clearTimeout(this.serverTimeoutObj);

          this.timeoutObj = setTimeout(() => {
            // 这里向后端发送一个心跳检测，后端收到后，会返回一个心跳回复
            this.vueThis.socketObj.send("HeartBeat");

            console.log("发送心跳检测");

            this.serverTimeoutObj = setTimeout(() => {
              // 如果超过一定时间还没重置计时器，说明websocket与后端断开了
              console.log("未收到心跳检测回复");
              // 关闭WebSocket
              this.vueThis.socketObj.close();
            }, this.timeout);
          }, this.timeout);

        },
      },
      socketReconnectTimer: null, // 计时器对象——重连
      socketReconnectLock: false, // WebSocket重连的锁
      socketLeaveFlag: false, // 离开标记（解决 退出登录再登录 时出现的 多次相同推送 问题，出现的本质是多次建立了WebSocket连接）
    }
  },
  mounted() {
    // websocket启动
    this.createWebSocket();
  },
  created() {
    if (!this.chatUser) {
      this.chatUser = this.chatPindao;
    }
    this.user = JSON.parse(sessionStorage.getItem("user"));
    console.log("离开标记", this.socketLeaveFlag);
  },
  destroyed() {
    // 离开标记
    this.socketLeaveFlag = true;
    // 关闭WebSocket
    this.socketObj.close();
  },
  methods: {
    // websocket启动
    createWebSocket() {
      let webSocketLink = "ws://1.15.75.55/foodie-api/imserver/" + this.user.username;
      //let webSocketLink = "ws://127.0.0.1:8088/foodie_api_war_exploded/imserver/" + this.user.username;
      try {
        if ("WebSocket" in window) {
          this.socketObj = new WebSocket(webSocketLink);
        } else if ("MozWebSocket" in window) {
          this.socketObj = new MozWebSocket(webSocketLink);
        }
        // websocket事件绑定
        this.socketEventBind();
      } catch (e) {
        console.log("catch" + e);
        // websocket重连
        this.socketReconnect();
      }
    },
    socketEventBind() {
      // 连接成功建立的回调
      this.socketObj.onopen = this.onopenCallback;
      // 连接发生错误的回调
      this.socketObj.onerror = this.onerrorCallback;
      // 连接关闭的回调
      this.socketObj.onclose = this.oncloseCallback;
      // 向后端发送数据的回调
      this.socketObj.onsend = this.onsendCallback;
      // 接收到消息的回调
      this.socketObj.onmessage = this.getMessageCallback;

      //监听窗口关闭事件，当窗口关闭时，主动去关闭websocket连接，防止连接还没断开就关闭窗口，server端会抛异常。
      window.onbeforeunload = () => {
        this.socketObj.close();
      };
    },
    // websocket重连
    socketReconnect() {
      if (this.socketReconnectLock) {
        return;
      }
      this.socketReconnectLock = true;
      this.socketReconnectTimer && clearTimeout(this.socketReconnectTimer);
      this.socketReconnectTimer = setTimeout(() => {
        console.log("WebSocket:重连中...");
        this.socketReconnectLock = false;
        // websocket启动
        this.createWebSocket();
      }, 4000);
    },
    // 连接成功建立的回调
    onopenCallback: function (event) {
      console.log("WebSocket:已连接");
      // 心跳检测重置
      //this.heartCheck.reset().start();
    },
    // 连接发生错误的回调
    onerrorCallback: function (event) {
      console.log("WebSocket:发生错误");
      // websocket重连
      this.socketReconnect();
    },
    // 连接关闭的回调
    oncloseCallback: function (event) {
      console.log("WebSocket:已关闭");
      // 心跳检测重置
      this.heartCheck.reset();
      if (!this.socketLeaveFlag) {
        // 没有离开--重连
        // websocket重连
        this.socketReconnect();
      }
    },
    // 向后端发送数据的回调
    onsendCallback: function () {
      console.log("WebSocket:发送信息给后端");
    },
    // 接收到消息的回调
    getMessageCallback: function (msg) {
      //console.log("收到数据====" + msg.data)
      //let data = JSON.parse(msg.data)  // 对收到的json数据进行解析， 类似这样的： {"users": [{"username": "zhang"},{ "username": "admin"}]}
      // console.log(msg.data);
      if (msg.data.indexOf("HeartBeat") > -1) {
        // 心跳回复——心跳检测重置
        // 收到心跳检测回复就说明连接正常
        console.log("收到心跳检测回复");
        // 心跳检测重置
        this.heartCheck.reset().start();
      } else {
        if (msg.data == "连接成功") {
          return
        }
        let data = JSON.parse(msg.data);
        if (data.users) {  // 获取在线人员信息
          this.user =JSON.parse(sessionStorage.getItem("user"));
          let username = this.user.username;
          this.users = data.users.filter(user => user.username !== username)
          // 获取当前连接的所有用户信息，并且排除自身，自己不会出现在自己的聊天列表里
          this.createContent(null, null, "此时村口来了一位修士");
        } else {
          // 如果服务器端发送过来的json数据 不包含 users 这个key，那么发送过来的就是聊天文本json数据
          //  // {"from": "zhang", "text": "hello"}
          if (data.from === this.chatUser) {
            this.messages.push(data)
            // 构建消息内容
            this.createContent(data.from, null, data.text)
          }
          if (data.pindao === this.chatUser) {
            this.messages.push(data)
            // 构建消息内容
            this.createContent(data.from, null, data.text)
          }
        }
        //this.messages.push(data.message);
        // 普通推送——正常处理
        console.log("收到推送消息");
        // 相关处理
      }
    },
    send() {
      if (!this.chatUser) {
        this.$Notice.info({title: "请选择聊天对象"});
        return;
      }
      if (!this.text) {
        this.$Notice.info({title: "请输入内容"});
      } else {
        if (typeof (WebSocket) == "undefined") {
          console.log("您的浏览器不支持WebSocket");
        } else {
          console.log("您的浏览器支持WebSocket");
          // 组装待发送的消息 json
          // {"from": "zhang", "to": "admin", "text": "聊天文本"}
          let message = {from: this.user.nickname, to: this.chatUser, text: this.text, pindao: this.chatPindao}
          this.socketObj.send(JSON.stringify(message));  // 将组装好的json发送给服务端，由服务端进行转发
          this.messages.push({user: this.user.nickname, text: this.text, pindao: this.chatPindao})
          // 构建消息内容，本人消息
          this.createContent(null, this.user.nickname, this.text)
          this.text = '';
        }
      }
    },
    /*send2(chatUser,text,pindao,fromt,socketObj) {
        if (typeof (WebSocket) == "undefined") {
          console.log("您的浏览器不支持WebSocket");
        } else {
          console.log("您的浏览器支持WebSocket");
          // 组装待发送的消息 json
          // {"from": "zhang", "to": "admin", "text": "聊天文本"}
          let message = {from: fromt, to: chatUser, text: text, pindao: pindao}
          socketObj.send(JSON.stringify(message));  // 将组装好的json发送给服务端，由服务端进行转发
          //this.messages.push({user: fromt, text: text, pindao: pindao})
          // 构建消息内容，本人消息
          //this.createContent(null, this.user.nickname, this.text)
          //this.text = '';
        }
    },*/
    createContent(remoteUser, nowUser, text) {  // 这个方法是用来将 json的聊天消息数据转换成 html的。
      let html
      // 当前用户消息
      if (nowUser) { // nowUser 表示是否显示当前用户发送的聊天消息，绿色气泡
        html = "<div class=\"el-row\" style=\"padding: 5px 0\">\n" +
          "  <div class=\"el-col el-col-22\" style=\"text-align: right; padding-right: 10px\">\n" +
          "   "+ nowUser+" <br> \n" +
          "    <div class=\"tip left\">" + text + "</div>\n" +
          "  </div>\n" +
          "  <div class=\"el-col el-col-2\">\n" +
          "  <span class=\"el-avatar el-avatar--circle\" style=\"height: 40px; width: 40px; line-height: 40px;\">\n" +
          "  </span>\n" +
          "  </div>\n" +
          "</div>";
      } else if (remoteUser) {   // remoteUser表示远程用户聊天消息，蓝色的气泡
        html = "<div class=\"el-row\" style=\"padding: 5px 0\">\n" +
          "  <div class=\"el-col el-col-2\" style=\"text-align: right\">\n" +
          "  <span class=\"el-avatar el-avatar--circle\" style=\"height: 40px; width: 40px; line-height: 40px;\">\n" +
          /*  "    <img src=\"https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png\" style=\"object-fit: cover;\">\n" +*/
          "  </span>\n" +
          "  </div>\n" +
          "  <div class=\"el-col el-col-22\" style=\"text-align: left; padding-left: 10px\">\n" +
          "   "+ remoteUser+"<br> \n" +
          "    <div class=\"tip right\">" + text + "</div>\n" +
          "  </div>\n" +
          "</div>";
      } else{
        html = "<p  style=\"text-align: center;padding: 8px 0;color: brown;\">"+text+"</p>\n" ;
      }
      console.log(html)
      this.content += html;
    },
  }
}
</script>
<style>
.tip {
  color: white;
  text-align: center;
  border-radius: 10px;
  font-family: sans-serif;
  padding: 10px;
  width:auto;
  display:inline-block !important;
  display:inline;
}
.right {
  background-color: deepskyblue;
}
.left {
  background-color: forestgreen;
}
</style>



// WEBPACK FOOTER //
// src/components/Im.vue